import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, map, take } from 'rxjs';
import { AuthService } from '../service/auth/auth.service';

/**
 * Guard para proteger rutas que requieren autenticación
 */
@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  /**
   * Constructor del guard
   */
  constructor(private authService: AuthService, private router: Router) {}

  /**
   * Verifica si se puede activar la ruta
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.checkAuth(state.url);
  }

  /**
   * Verifica si se pueden activar las rutas hijas
   */
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canActivate(childRoute, state);
  }

  /**
   * Comprueba si el usuario está autenticado
   * @param url URL intentada
   */
  private checkAuth(url: string): Observable<boolean | UrlTree> {
    return this.authService.isAuthenticated$.pipe(
      take(1),
      map((isAuthenticated) => {
        if (isAuthenticated) {
          return true;
        }

        // Guardar URL para redirección después del login
        this.storeRedirectUrl(url);

        // Redirigir al login
        return this.router.createUrlTree(['/login']);
      })
    );
  }

  private storeRedirectUrl(url: string): void {
    if (url && url !== '/' && !url.includes('/login')) {
      sessionStorage.setItem('redirectUrl', url);
    }
  }
}
